<template>

  <v-expansion-panel class="alarm-item" :class="{ inactive: !alarm.active }">
    <!-- header -->
    <v-expansion-panel-header class="d-flex pa-2">
      <div class="alarm-icons flex-grow-0 text-center">
        <alarm-severity :alarm="alarm"></alarm-severity>
        <v-checkbox v-if="!alarm.issueId" :input-value="selection" :value="alarm" @click.stop="select($event)"></v-checkbox>
      </div>

      <div class="ml-3">
        <div class="font-weight-bold">{{ alarm.asset.assetParentsView.fullPath }}</div>
        <div>{{ type }}</div>
        <div class="mt-2 text-small d-flex justify-space-between">
          <div>{{ alarm.detectedAt | datetime }}</div>
          <div>
            <alarm-status :alarm="alarm"></alarm-status>
          </div>
        </div>
      </div>
    </v-expansion-panel-header>

    <!-- content -->
    <v-expansion-panel-content>
      <div class="controls">
        <alarm-controls :alarm="alarm" @map="$emit('map', $event)" @create-issue="$emit('create-issue', $event)" @removed="$emit('removed', $event)"></alarm-controls>
      </div>
    </v-expansion-panel-content>
  </v-expansion-panel>

</template>

<script>
  import AlarmControls from '@/observer/alarms/components/alarm-controls'
  import AlarmSeverity from '@/observer/alarms/components/alarm-severity'
  import AlarmStatus from '@/observer/alarms/components/alarm-status'

  export default {
    name: 'alarm-panel-item',

    props: [ 'alarm', 'selection' ],

    computed: {
      type () {
        return this.alarm.alarmType === 'disconnected' ? this.$t('alarm.disconnected') : this.$t(`alarm.type.${this.alarm.asset.deviceType}.${this.alarm.alarmType}`)
      },
    },

    components: {
      AlarmStatus,
      AlarmSeverity,
      AlarmControls,
    },

    methods: {
      select () {
        const selection = this.selection.includes(this.alarm)
          ? this.selection.filter(x => x !== this.alarm)
          : [ ...this.selection, this.alarm ];

        this.$emit('selected', selection)
      }
    }
  }
</script>

<style scoped lang="scss">

  @import '../../assets/variables';

  .alarm-item {
    border-bottom: 1px solid $color-gray;
    padding: 0 $spacing-default;
    margin: 0;
    word-break: break-all;
    flex-basis: auto;

    &:before,
    &:after {
      display: none;
    }

    .v-expansion-panel-header:before {
      display: none;
    }

    &.inactive {
      opacity: 0.5;
    }

    .alarm-icons {
      ::v-deep {
        .v-icon,
        .v-input,
        .v-input__slot,
        .v-input--selection-controls__input {
          margin: 0;
          padding: 0;
        }

        .v-messages {
          display: none;
        }

        & > * {
          margin: $spacing-small 0 !important;
        }
      }
    }

    .controls {
      text-align: right;
    }
  }

</style>
